// Helper condivisi per decidere i campi input in esecuzione allenamento
// in base a exercise_type e uses_weight (catalogo pulito).

// Esercizio "a tempo": tempo/isometrico → mostra secondi, non reps.
export const isTimeType = (t) => t === 'time' || t === 'hold';

// Esercizio cardio → mostra durata/distanza. Manteniamo il rilevamento legacy
// basato su duration_minutes (impostato in scheda) per non alterare il salvataggio
// esistente dei cardio (il ramo save cardio dipende da questa condizione).
export const isCardioType = (ex) => ex?.duration_minutes != null;

// Mostra il campo kg? No per time/hold/cardio/distance o se uses_weight=false.
// Default true (retro-compatibile con dati senza il flag).
export const usesWeight = (ex) => {
  if (!ex) return true;
  if (ex.uses_weight === false || ex.usesWeight === false) return false;
  const t = ex.exercise_type;
  if (t === 'time' || t === 'hold' || t === 'cardio' || t === 'distance') return false;
  return true;
};
